// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IPollExtractActionStatusRequestParams {
  id: string;
  contentType: string;
  actionType: string;
}

export interface IPollExtractActionStatusResult extends IResult {
  pending: boolean;
}

export class PollExtractActionStatusRequest extends Request<IPollExtractActionStatusRequestParams, IPollExtractActionStatusResult> {
  constructor(params: IPollExtractActionStatusRequestParams) {
    super('pollExtractActionStatus', params);
  }
}
